// CENTRALIZED CUSTOMER-FACING CONTENT
// Rooney: edit the text below to change what customers see on the public pages.
// Every entry was moved here verbatim from its page component - the page imports it from this one file.
// Module titles live in backend/course_content.py; customer email templates live in
// backend/marketing_service.py, backend/accountability_service.py and the *_routes.py email builders.
export const SITE_CONTENT = {
  "memberVideos": {
    "boardFixOrientation": "bzAzMihfGQY"
  },
  "shared": {
    "guaranteeHeading": "100% Money-Back Guarantee",
    "guaranteeSentence": "Your investment is protected by our 100% money-back guarantee.",
    "guaranteePrefix": "Your investment is protected by our ",
    "guaranteeStrong": "100% money-back guarantee."
  },
  "recruitWithRooney": {
    "headline": "Recruit the Board Members Your Nonprofit Needs in 2 Weeks"
  },
  "reactivateWithRooney": {
    "headline": "Reactivate Your Board Without Destroying Relationships"
  },
  "activateWithRooney": {
    "headline": "Turn Your Board Into Fundraising Champions for Your Mission"
  },
  "recruitDiy": {
    "headline": "Recruit Your Board Yourself",
    "cta": "MAKE PAYMENT AND START RECRUITING MY BOARD"
  },
  "reactivateDiy": {
    "headline": "Reactivate Your Board Yourself",
    "cta": "MAKE PAYMENT AND START REACTIVATING MY BOARD"
  },
  "activateDiy": {
    "headline": "Activate Your Board to Start Raising Money",
    "cta": "MAKE PAYMENT AND START ACTIVATING MY BOARD"
  },
  "recruitProposal": {
    "headline": "Build the Board Your Nonprofit Needs",
    "cta": "MAKE PAYMENT — LET'S START RECRUITING YOUR BOARD TOGETHER"
  },
  "reactivateProposal": {
    "headline": "Stop Carrying Dead Weight on Your Board",
    "cta": "MAKE PAYMENT — LET'S REACTIVATE YOUR BOARD TOGETHER"
  },
  "activateProposal": {
    "headline": "Turn Your Board Into Fundraising Champions for Your Mission",
    "cta": "MAKE PAYMENT — LET'S ACTIVATE YOUR BOARD TOGETHER"
  },
  "recruitStartHere": {
    "headline": "You're Ready to Start Recruiting Your Board",
    "cta": "START STEP 1 — RECRUITING BOARD MEMBERS THE RIGHT WAY"
  },
  "reactivationStartHere": {
    "headline": "Start Here: Reactivate Your Board",
    "cta": "START REACTIVATING MY BOARD"
  },
  "activationStartHere": {
    "headline": "Activate Your Board to Start Raising Money",
    "cta": "START ACTIVATING MY BOARD"
  },
  "aboutRooney": {
    "headline": "Rooney Akpesiri",
    "offers": {
      "recruit": {"heading": "Recruit New Board Members", "copy": "Bring the right people with the right skills and experience into your board in 2 weeks."},
      "reactivate": {"heading": "Reactivate Your Board", "copy": "Get Your board members To Step Up and Those no longer willing to continue to step down without damaging your relationships"},
      "activate": {"heading": "Build A Fundraising Board", "copy": "Get Your Board To Raise Money and Build Your Organization's fundraising system."}
    }
  },
  "home": {
    "cta": "Show Me How to Fix My Board",
    "heroCta": "I'm Ready",
    "introCta": "Show Me How to Fix My Board",
    "introSectionParagraphs": [
      "Building the right board doesn't happen by chance. It is Intentionally Orchestrated.",
      "This is why our mission as nonprofit board builders is to empower founders and executive directors like you with the framework, tools, and support you need to build the right board for your nonprofit.",
      "We will work with you to get your present board to recommit and step up to their responsibilities, recruit new board members to complement and strengthen your present board, and activate both your current and new board members to start raising money and building your organization's fundraising system."
    ],
    "builderHeading": "Become a Nonprofit Board Builder",
    "builderSubheading": "Learn the process. Get the tools. Execute the transformation.",
    "builderParagraph": "You don't have to waste time handling the process. You don't have to guess through the process. Simply use the tools as instructed and begin to transform your board into the powerhouse board your mission needs.",
    "builderPillars": [
      {"label": "RECRUIT", "text": "Recruit the right people to strengthen your board."},
      {"label": "REACTIVATE", "text": "Get your current board members to step up and take responsibility, or help them transition gracefully when they can no longer continue."},
      {"label": "ACTIVATE", "text": "Get your board working with you to raise money and build your organization's fundraising system."}
    ],
    "heroTitle": "Are These 3 Board Mistakes Costing Your Nonprofit Funding?",
    "heroSubtitle": "Discover the three mistakes that could be limiting your organization's ability to raise money consistently and exponentially, and what to do about them.",
    "leadFormPrompt": "Enter your details below to get instant access and have it emailed to you.",
    "leadFormCta": "SHOW ME THE 3 MISTAKES",
    "introHeading": "Your board is one of your organization's strongest assets.",
    "introParagraphs": [
      "When you have a great board, the nonprofit journey becomes an adventure. You raise money, build strong organizational structures, create greater impact, and grow steadily because you have the right people in the right positions providing the kind of support your organization needs.",
      "But when you have the wrong board, the nonprofit journey becomes a ride uphill.",
      "Your board may be passive or disengaged. You may have the wrong people occupying important seats. Your board may have become a bottleneck to growth, or you may barely have a functioning board at all.",
      "You may even have an active board that attends meetings and cares deeply about the mission, but still does not provide the kind of support you need to raise money and move the organization forward.",
      "When this continues, funding becomes harder. Growth becomes harder. The founder or executive director carries responsibilities that should be shared across the organization, and eventually the mission itself begins to suffer.",
      "This is why we built Nonprofit Board Builder.",
      "Our mission is to empower nonprofit founders and executive directors like you with the system, tools, resources, and support you need to build a strong board that works with you to move your organization forward.",
      "We have spent years developing and using the processes, tools, templates, scripts, and frameworks required to transform nonprofit boards.",
      "Now, we want to hand the complete process to you and support you as you execute it inside your own organization.",
      "If you are ready to strengthen your board, answer four important questions about where your board is today.",
      "Based on your answers, I will show you where I believe you should begin, the exact steps you can start taking to fix your board, and how to build the kind of board your mission needs.",
      "This is why at Nonprofit Board Builders, we are dedicated to supporting nonprofit founders and executive directors to build strong fundraising boards that can help their organization succeed."
    ],
    "howHeading": "Here's How We Can Help You",
    "howParagraphs": [
      "You tell us about your organization by answering just five questions.",
      "Based on our encoded framework, you will get immediate access to the exact steps you can take to recruit new board members, reactivate your present board, and activate your entire board to start raising money and building your organization's fundraising system.",
      "You can either choose to fix, build, and transform your board yourself following clear instructions or you can bring us in to go through the process with you, providing you every support you need to succeed."
    ],
    "nav": {
      "successStories": "Success Stories",
      "myStory": "My Story",
      "joinABoard": "Join a Board",
      "reactivate": "Reactivate",
      "recruit": "Recruit",
      "activate": "Activate",
      "logIn": "Log In"
    },
    "finalCta": {
      "eyebrow": "A board built for impact",
      "heading": "Build the Board Your Nonprofit Needs to Raise Money and Fulfil Its Mission",
      "reactivateButton": "Reactivate My Board",
      "recruitButton": "Recruit My Board",
      "activateButton": "Activate My Board to Raise Money"
    },
    "joinNetwork": {
      "eyebrow": "Professional board service",
      "heading": "Are You a Professional Looking to Join a Nonprofit Board?",
      "text": "Create your professional profile, tell us the causes you care about and receive board opportunities that match your skills, experience, location and availability.",
      "button": "Join the Board Applicant Network"
    },
    "footer": {
      "statement": "Nonprofit Board Builder helps nonprofits reactivate, recruit and activate powerhouse fundraising boards.",
      "about": "About",
      "contact": "Contact",
      "privacy": "Privacy Policy",
      "terms": "Terms"
    }
  },
  "testimonialsSection": {
    "eyebrow": "Success stories",
    "heading": "Nonprofit Leaders We Have Helped Build Stronger Boards and Fundraising Systems"
  },
  "founderStory": {
    "eyebrow": "The Story Behind the Process",
    "heading": "I Didn't Learn This From a Book. I Built It From Experience.",
    "name": "Rooney Akpesiri, CNC, CDE, CNE",
    "title": "The Nonprofit Board Builder",
    "photoCaption": "Rooney Akpesiri",
    "paragraphs": [
      "I'm Rooney. Known to many as the Nonprofit Board Builder.",
      "My journey started many years ago as a nonprofit founder. I built my first board, made mistakes, damaged relationships, learned some difficult lessons, rebuilt my board, and eventually developed a process that worked.",
      "Since then, I have experienced nonprofit leadership from almost every side.",
      "I have founded and led a nonprofit. I have served on nonprofit boards. I have worked directly with founders and executive directors as a fundraising consultant. I served as Vice President of Client Acquisition and later Vice President of Client Services for a fundraising consulting firm working with nonprofits across the United States.",
      "I have trained hundreds of nonprofit founders and fundraisers, worked with organizations across the country to strengthen their boards and fundraising systems, and contributed to fundraising efforts that have generated more than $5 million.",
      "But one lesson has remained consistent throughout all of that experience:",
      "Everything rises and falls on leadership.",
      "I have watched founders struggle because they were trying to build, fund and carry their organizations almost entirely by themselves.",
      "And I have watched what happens when the right board is built around a leader, understands where the organization is going, and has the skills, experience and structure to help get it there.",
      "That is why I became the Nonprofit Board Builder.",
      "Today, I help founders and executive directors build the right board and work with their board to build the fundraising capacity and systems their organizations need to raise money, grow and achieve their mission.",
      "You don't have to figure this out by yourself or repeat the mistakes I made.",
      "I built the process. Now I can show you how to use it."
    ],
    "bookCallButton": "Book a Call With Rooney",
    "credibility": [
      "Served on nonprofit boards",
      "Former Vice President of a fundraising consulting firm",
      "Trained hundreds of nonprofit founders and fundraisers",
      "Worked with nonprofits across the United States",
      "Contributed to raising more than $5 million"
    ]
  },
  "boardTransformation": {
    "headline": "What Does This Board Actually Need?",
    "intro": "Tell us about your organization by answering just five questions. We will show you the exact steps you can take to fix, build, and transform your board."
  },
  "boardTransformationResult": {
    "headline": "Your Board Transformation Journey",
    "videoPlaceholder": "Board Transformation Video Coming Soon",
    "chooseHeading": "Which Would You Like to Do First?",
    "recommendedBadge": "Recommended for your board",
    "offers": {
      "recruitment": "Recruit New Board Members",
      "reactivation": "Reactivate Your Board",
      "activation": "Activate Your Board Around Fundraising"
    }
  },
  "offerSalesPages": {
    "board-fix": {
      "title": "Your Board Training: The 3 Mistakes",
      "lead": "Watch this short video to discover the three board mistakes I see nonprofit founders and executive directors make and what you can begin doing differently.",
      "video": {
        "youtubeId": "KDCnKeJoPRc",
        "title": "The 3 Board Mistakes Training"
      },
      "options": {
        "diy": {
          "heading": "Complete Board Fix System",
          "regularPrice": "$997",
          "price": "$497",
          "discountNote": "50% OFF — $497 for the next 7 days",
          "paragraphs": [
            "Everything you need to fix your board yourself — the complete process, tools, resources and support to rebuild your present board, recruit the board members you need, and get your entire board raising money and building your organization with you."
          ],
          "buttonLabel": "Get the Complete Board Fix System — $497"
        },
        "dwy": {
          "heading": "Do It With Me",
          "price": "$5,497",
          "paragraphs": [
            "Everything in the Complete Board Fix System — and I work through the entire process with you. After you complete your intake, you will schedule your first session with me, and we will fix your board together, stage by stage, until your board is working the way your mission needs."
          ],
          "buttonLabel": "Do It With Me — $5,497"
        }
      }
    },
    "checkoutError": "We could not start checkout. Please try again in a moment.",
    "startingCheckout": "Starting Checkout…",
    "guarantee": "Your investment is protected by my 100% refund guarantee.",
    "recruitment": {
      "title": "Recruit New Board Members",
      "video": {
        "youtubeId": "DKQzQM3e6CU",
        "title": "Launch Your Board Recruitment Campaign in 30 Minutes & Get The Quality Support Your Nonprofit Needs"
      },
      "campaignLaunch": {
        "offerName": "Recruitment Campaign Launch",
        "outcomeHeading": "Your Outcome",
        "guaranteeHeading": "100% Guarantee",
        "guaranteeBody": "We guarantee that if you don't get the kind of applicants you need, you get a 100% refund.",
        "price": "$697",
        "buttonLabel": "LAUNCH MY BOARD RECRUITMENT CAMPAIGN — $697"
      },
      "lead": "How you recruit your board members is as important as the quality of board members you recruit.",
      "opening": [
        "Most founders think board recruitment is simply about finding good people and inviting them onto the board.",
        "You find someone with good skills. You invite them in. They show up for the first meeting. And now you have a board member.",
        "But here's the problem.",
        "People brought in that way don't always see the importance of the work or the professionalism of the organization.",
        "And when things get hard, they start giving you stories.",
        "Before you know it, you're right back to where you started, running the organization all by yourself and spending your own resources.",
        "I've been there. I know how it feels.",
        "But you can actually recruit right.",
        "You can have board members who participate, show up and commit to your mission.",
        "It depends on how you recruit them."
      ],
      "sections": [
        {
          "heading": "There is a right way to recruit your board.",
          "paragraphs": [
            "Think about how you bring an employee into your organization.",
            "They apply.",
            "You interview them.",
            "You conduct reference or background checks where necessary.",
            "You onboard them.",
            "You make sure they understand their responsibilities and expectations.",
            "That process matters because it shows people the importance, seriousness and professionalism of the organization they are joining.",
            "Board members deserve the same process.",
            "When you recruit this way, people understand what they are joining and what is expected of them from the beginning."
          ]
        },
        {
          "heading": "You don't need a big network.",
          "paragraphs": [
            "What you need is the ability to execute the right recruitment process.",
            "We can help you launch your recruitment campaign across multiple audiences, including people within your network, professionals looking to give back, recruitment platforms, and people who can refer qualified candidates."
          ]
        },
        {
          "heading": "We've seen how quickly this can move.",
          "paragraphs": [
            "In our last recruitment campaign a few days ago, we had over 51 applicants in less than 48 hours for an organization that has yet to get its 501(c)(3), with over 22 interviews booked.",
            "The organization selected eight new board members and recommended seven others for the advisory board, as there was no remaining space on the board under their bylaws.",
            "This is how fast your recruitment can move when the process is executed properly."
          ]
        },
        {
          "heading": "We'll help you get your recruitment campaign moving.",
          "paragraphs": [
            "Over the next 30 minutes, we can launch your board recruitment campaign.",
            "Within 48 hours, you can begin selecting the people you want to move forward with.",
            "Once you've made your selections, the onboarding process gets them into their responsibilities so they can start contributing to your organization.",
            "And you have two ways to do it."
          ]
        }
      ],
      "diy": {
        "heading": "RECRUIT YOUR BOARD YOURSELF",
        "price": "$297",
        "paragraphs": [
          "Get access to the guidance, tools, and materials you need to recruit your board yourself; everything created specifically for you and your organization.",
          "You'll see exactly how we execute each step of the process, then replicate it using the resources we've created specifically for you.",
          "You also have our immediate support available when you need it, plus access to hundreds of professionals across the U.S who have indicated interest in giving back by joining a nonprofit board whose mission they care about."
        ],
        "buttonLabel": "DO IT YOURSELF"
      },
      "dwy": {
        "heading": "DO IT WITH US",
        "price": "",
        "paragraphs": [
          "Want us to step in and help you execute the recruitment?",
          "We'll help launch your recruitment campaign.",
          "You select the people you want to move forward with.",
          "Then we step back in to help onboard your new board members and get them started with their responsibilities."
        ],
        "buttonLabel": "DO IT WITH US"
      },
      "closing": {
        "heading": "Let's get your board recruited.",
        "paragraphs": [
          "Choose the level of support you need and let's get started."
        ],
        "showButtons": false,
        "diyLabel": "DO IT YOURSELF",
        "dwyLabel": "DO IT WITH US"
      }
    },
    "reactivation": {
      "title": "Reactivate Your Board",
      "lead": "Your nonprofit deserves the right leadership.",
      "opening": [
        "Your organization deserves a board that is active, engaged, and committed to ensuring the mission and vision of the organization are achieved.",
        "But maybe that isn't the reality right now.",
        "Some board members have gone silent. Some are inactive. Some are disengaged. Some may even have become hostile.",
        "And really, there's no one to blame.",
        "Most board members do care. They want to support. They love the mission. Some may even be helping in their own personal capacity.",
        "You care too. You want to work with them. You want to get the best out of them.",
        "But somehow, it isn't working.",
        "The good thing is this: your board can be reactivated.",
        "We can get your board members to recommit, step up, accept responsibility, and begin working with you to build the organization.",
        "But there is a clear process for doing that.",
        "We call it the Board Reactivation Process."
      ],
      "sections": [
        {
          "heading": "The Board Reactivation Process",
          "paragraphs": [
            "Board reactivation is all about understanding why your board was or is the way it is, making the necessary corrections, having the difficult conversations, and moving every board member forward in a way that best serves the board member and the organization.",
            "For some, that means stepping up, accepting responsibility, and taking on a clear portfolio.",
            "For others, it may mean stepping down from the board and the organization, or simply stepping into another aspect of the organization, such as the advisory board.",
            "The goal at the end is to make sure you aren't carrying any deadweight while creating the space for the right people who can help create results for your organization to step in."
          ]
        },
        {
          "heading": "You can start immediately.",
          "paragraphs": [
            "In the next 10 minutes, we can start the Board Recommitment process.",
            "Over the next week, we can get your board recommitted and eager to start creating results with you.",
            "We've done this process over and over again.",
            "We understand how to get board members to respond, even when they no longer pick up calls, respond to emails, or seem available.",
            "And there are two ways you can execute, depending on the kind of support you need and the resources you have available."
          ]
        }
      ],
      "diy": {
        "heading": "DO IT YOURSELF",
        "subheading": "Follow the process yourself with everything you need.",
        "price": "$497",
        "paragraphs": [
          "You'll get the instructions and tailored materials required to execute the Board Reactivation Process.",
          "You execute the process yourself, with support available as you reactivate your board."
        ],
        "buttonLabel": "GET STARTED ($497)"
      },
      "dwy": {
        "heading": "DO IT WITH YOU",
        "subheading": "Get Rooney to step in and help you through the process.",
        "price": "$5,497",
        "paragraphs": [
          "We'll work with you to initiate the process, lead you through it, guide you through the difficult conversations, and support you as you work to reactivate your board.",
          "The goal is simple:",
          "Get your board members back active, committed, and contributing to the mission."
        ],
        "buttonLabel": "GET STARTED WITH ROONEY ($5,497)"
      },
      "closing": {
        "heading": "Reactivate Your Board",
        "paragraphs": [
          "If you're ready to get your board moving again, choose the level of support you need; let's get you started and your board reactivated."
        ],
        "showButtons": true,
        "diyLabel": "DO IT YOURSELF",
        "dwyLabel": "DO IT WITH YOU"
      }
    },
    "activation": {
      "title": "Build a Fundraising Board",
      "lead": "Your board has a responsibility to ensure your organization is adequately funded.",
      "opening": [
        "I'll repeat it.",
        "It is your board's responsibility to ensure that your organization is adequately funded.",
        "But sadly, many boards don't know this.",
        "They think fundraising is the founder's responsibility. The founder raises the money, while the board provides oversight and holds the founder accountable.",
        "That leaves too much responsibility falling back on you.",
        "And your board can actually help you raise money.",
        "The challenge is that most board members aren't professional fundraisers.",
        "Some don't know how to raise money. Some don't feel comfortable asking people for money. And when you simply tell them to go raise a certain amount, they can quickly become disengaged when they don't know how to do it.",
        "There is a better way to activate your board for fundraising.",
        "We call it the Board Fundraising Activation Process."
      ],
      "sections": [
        {
          "heading": "Your board can raise money from their strengths.",
          "paragraphs": [
            "Getting your board to raise money isn't about simply telling them to go raise $10,000.",
            "It isn't about handing them fundraising tools and expecting them to figure it out.",
            "It's about creating the foundation that allows each board member to contribute in the way that best fits their strengths, expertise, network, and willingness to serve.",
            "The Board Fundraising Activation Process helps you move your board from simply knowing that fundraising is their responsibility to actually participating in it.",
            "When you do this properly, each board member can have a clear fundraising role while helping build the organization's overall fundraising system.",
            "That's what gets your board members up and active in fundraising.",
            "The result is a board that is actively helping your organization build its capacity to raise money."
          ]
        },
        {
          "heading": "You can start immediately.",
          "paragraphs": [
            "We've been in this space for years, have tried different ways of getting boards to raise money, and contributed to raising $5m for nonprofits across the US.",
            "We've discovered what works.",
            "And there are two ways you can execute the process."
          ]
        }
      ],
      "diy": {
        "heading": "DO IT YOURSELF",
        "subheading": "Get everything you need to activate your board for fundraising.",
        "price": "$497",
        "paragraphs": [
          "You'll get the instructions, tools, materials, and resources required to execute the Board Fundraising Activation Process yourself.",
          "You'll follow the process, engage your board, and begin moving your board members into active fundraising roles.",
          "This is for self starters and leaders who can execute when provided the path and tools."
        ],
        "buttonLabel": "DO IT YOURSELF"
      },
      "dwy": {
        "heading": "DO IT WITH YOU",
        "subheading": "Get Rooney to work with you through the process.",
        "price": "$5,497",
        "paragraphs": [
          "We'll work with you throughout the process, helping you activate your board and move your board members into active fundraising roles.",
          "We'll help you make sure the process is executed properly for your organization so your board can start raising money and building the organization's fundraising capacity."
        ],
        "buttonLabel": "DO IT WITH YOU"
      },
      "closing": {
        "heading": "Build A Fundraising Board",
        "paragraphs": [
          "Your board can do more than provide oversight.",
          "They can help build your organization's fundraising capacity and ensure your organization is adequately funded.",
          "Choose the level of support you need and let's get started."
        ],
        "showButtons": true,
        "diyLabel": "DO IT YOURSELF",
        "dwyLabel": "DO IT WITH YOU"
      }
    }
  }
};

// ---- AUTO-MIGRATED CANONICAL CONTENT (platform-wide centralization) ----

export const operatorModeText = {
  testModeAdminProductJourney: "TEST MODE \u2014 Admin Product Journey (isolated test workspace, no emails are sent automatically, no real client data is affected)",
};

export const opportunityPagesText = {
  uploadRSumCv: "Upload r\u00e9sum\u00e9/CV ",
  yourApplicationHasBeenSubmitted: "Your Application Has Been Submitted",
  wouldYouLikeToCreate: "Would you like to create a Board Applicant profile so we can notify you about future nonprofit board opportunities? ",
  joinTheBoardApplicantNetwork: "Join the Board Applicant Network",
  thisRecruitmentCampaignIsNo: "This recruitment campaign is no longer accepting applications.",
  applyToJoinTheBoard: "Apply to Join the Board",
  youHaveAlreadyApplied: "You Have Already Applied",
  anApplicationFromYourProfile: "An application from your profile has already been submitted for this opportunity.",
  applyWithUpdatedInformation: "Apply With Updated Information",
  applyWithUpdatedInformation2: "Apply With Updated Information",
  updateAnythingThatHasChanged: "Update anything that has changed for this opportunity. Fields you leave blank keep your saved profile information. A new CV upload is optional \u2014 your saved CV is used otherwise.",
  alsoUpdateMyBoardApplicant: "Also update my Board Applicant profile with these changes",
  iHaveReadAndAgree: "I have read and agree to the terms of this agreement.",
  typeMyNameToSign: "Type My Name to Sign",
  orUploadASavedSignature: "Or upload a saved signature image (PNG or JPG)",
  thisElectronicSignatureProcessDoes: "This electronic signature process does not constitute legal advice. The organization remains responsible for determining whether its document and signature process meets its legal requirements.",
};

export const referencePagesText = {
  howLongHaveTheyKnown: "How long have they known or worked with you? *",
  boardAppointmentReferenceProcess: "Board Appointment Reference Process",
  provideYourProfessionalReferences: "Provide Your Professional References",
  yourReferencesHaveBeenRecorded: "Your References Have Been Recorded",
  iConfirmThatIHave: "I confirm that I have permission to provide my referees' contact information for this reference process.",
  iConfirmThatTheInformation: "I confirm that the information I have provided reflects my own experience and knowledge of the candidate. *",
};

export const aboutRooneyPageText = {
  theNonprofitBoardBuilder: "The Nonprofit Board Builder",
  answerFourShortQuestionsAbout: "Answer four short questions about your Board and I will show you the steps to take to fix it and build a Board that helps carry your mission.",
  tellMeWhatMyBoard: "TELL ME WHAT MY BOARD NEEDS",
  threeWaysICanHelp: "Three Ways I Can Help You Transform Your Board",
  chooseThePartOfThe: "Choose the part of the Board Transformation journey your organization needs first.",
  theNonprofitBoardBuilder2: "The Nonprofit Board Builder",
  imRooneyKnownToMany: "I'm Rooney. Known to many as the Nonprofit Board Builder.",
  iStartedAsANonprofit: "I started as a nonprofit founder many years ago, where I built my first board.",
  iMadeMistakesDamagedRelationships: "I made mistakes, damaged relationships, learned from the experience, rebuilt my board, and eventually developed a process that worked.",
  sinceThenIHaveServed: "Since then, I have served on nonprofit boards, worked as a fundraising consultant, served as Vice President of a fundraising consulting firm working with nonprofits across the United States, trained hundreds of nonprofit founders and fundraisers, helped nonprofits strengthen their boards, and contributed to raising more than $5 million.",
  todayITeachCoachAnd: "Today, I teach, coach, and work directly with founders and executive directors so they do not make the mistakes I made, damage their relationships, or waste their time.",
  wantToDiscussYourBoard: "Want to Discuss Your Board With Me?",
  ifYouWantToTalk: "If you want to talk through where your Board is today, what you are trying to build, and whether I can help, book a call with me and let's discuss it.",
  bookACallWithRooney: "BOOK A CALL WITH ROONEY",
  rooneyAkpesiriTheNonprofitBoard: "Rooney Akpesiri, The Nonprofit Board Builder",
};

export const activateWithRooneyPageText = {
  yourBoardShouldUnderstandThe: "Your Board should understand the fundraising direction, help build the plan, take ownership of the work and know exactly how they can help raise money for the organization. You can lead the process yourself with my guidance and tools, or I can work through the process with you.",
  boardFundraisingActivationVideoComing: "Board Fundraising Activation Video Coming Soon",
  twoWaysICanHelp: "Two Ways I Can Help You Activate Your Board",
  chooseTheLevelOfSupport: "Choose the level of support that works best for you.",
  activateYourBoardYourself: "Activate Your Board Yourself",
  leadYourBoardThroughThe: "Lead your Board through the complete fundraising activation process yourself, with the process, tools and support you need to move from Board disengagement in fundraising to Board ownership and execution \u2014 get the Board involved in building the fundraising plan, turn everyone's ideas into one fundraising strategy, bring the plan back to the Board for review, facilitate adoption, establish clear responsibility and equip Board Members with practical fundraising tools.",
  iWantToActivateMy: "I WANT TO ACTIVATE MY BOARD MYSELF",
  activateYourBoardWithRooney: "Activate Your Board With Rooney",
  rooneyWorksThroughTheBoard: "Rooney works through the Board Fundraising Activation process with you so your organization does not have to figure out how to turn Board Members into fundraising participants alone \u2014 Board participation in planning, one fundraising strategy, Board review and adoption, clear ownership, practical execution, and a founder who is no longer carrying fundraising alone.",
  iWantRooneyToHelp: "I WANT ROONEY TO HELP ACTIVATE MY BOARD",
  activateYourBoardWithRooney2: "Activate Your Board With Rooney",
};

export const activateYourBoardYourselfPageText = {
  stopCarryingFundraisingAlone: "Stop Carrying Fundraising Alone",
  youShouldNotBeThe: "You should not be the only person carrying the fundraising responsibility for your organization. Your Board should understand what the organization is trying to fund, help build the fundraising strategy, take ownership of the plan, accept clear responsibilities and have the tools they need to begin taking action.",
  peopleWhoPlanTogetherExecute: "People Who Plan Together Execute Together",
  theGoalIsNotTo: "The goal is not to create a fundraising plan by yourself and then hand it to your Board. The Board participates in building the plan so members understand where the strategy came from, see their own ideas reflected in it, and are more prepared to take ownership of execution.",
  whatChangesWhenYouFollow: "What Changes When You Follow the Process",
  youAreDoingItYourself: "You Are Doing It Yourself. You Are Not Doing It Alone.",
  youAreFollowingMyComplete: "You are following my complete process for taking a Board from limited fundraising participation to ownership and execution \u2014 and you have the tools and support structure you need to execute it.",
  noMonthlyMembershipNoSubscription: "No monthly membership. No subscription.",
  yourPaymentWasNotCompleted: "Your payment was not completed. You can get started whenever you're ready.",
  wantMeToDoIt: "Want Me To Do It With You?",
};

export const activationStartHerePageText = {
  youAreAboutToTake: "You are about to take your Board through a process that gets them involved in building the fundraising plan, agreeing how the Board will help carry it, and equipping members to begin taking action.",
  doNotSimplyTellYour: "Do not simply tell your Board to raise money.",
  buildThePlanWithThem: "Build the plan with them.",
  peopleWhoPlanTogetherExecute: "People who plan together execute together.",
};

export const areaPackPageText = {
  submitAnUpdatedVersion: "Submit an Updated Version",
  takeTheAgreedFoundationAbove: "Take the agreed foundation above and develop the detailed plan for your area. Paste or write your completed plan below.",
};

export const boardActivationIntakePageText = {
  pleaseWaitWhileWeVerify: "Please wait while we verify your payment with Stripe.",
  weCouldNotFindA: "We could not find a completed qualifying purchase. If you just paid, please use the link Stripe returned you to. Otherwise, choose how you would like to activate your board:",
  doItYourself497: "Do It Yourself \u2014 $497",
  doItWithRooney2: "Do It With Rooney \u2014 $5,497",
  takingYouToYourStart: "Taking you to your start page\u2026",
  openMyStartPage: "Open My Start Page",
  takingYouToTheCalendar: "Taking you to the calendar\u2026",
};

export const boardActivationProposalPageText = {
  boardFundraisingActivationProjectProposal: "Board Fundraising Activation Project Proposal",
  stopCarryingFundraisingAloneWe: "Stop Carrying Fundraising Alone \u2014 We Will Activate Your Board Together",
  fundraisingShouldNotSitAlmost: "Fundraising should not sit almost entirely on the founder or executive director while the Board remains on the sidelines.",
  thePurposeOfThisProject: "The purpose of this project is to work with your organization through a structured Board Fundraising Activation process that gets Board Members involved in building the fundraising plan, reviewing and adopting the strategy, accepting clear responsibilities and becoming equipped to help execute it.",
  theOutcomeIsNotSimply: "The outcome is not simply a fundraising document.",
  theOutcomeIsABoard: "The outcome is a Board that understands the fundraising direction, has participated in shaping it, knows what it is responsible for and is better equipped to help the organization raise money.",
  whatWeWillAccomplishTogether: "What We Will Accomplish Together",
  iWorkThroughTheProcess: "I work through the process ",
  youYourOrganizationIsNot: " you \u2014 your organization is not simply purchasing documents.",
  yourPaymentWasNotCompleted: "Your payment was not completed. You can get started whenever you're ready.",
  preferToDoItBy: "Prefer to Do It By Yourself?",
};

export const boardReactivationIntakePageText = {
  pleaseWaitWhileWeVerify: "Please wait while we verify your payment with Stripe.",
  weCouldNotFindA: "We could not find a completed qualifying purchase. If you just paid, please use the link Stripe returned you to. Otherwise, choose how you would like to reactivate your board:",
  doItYourself497: "Do It Yourself \u2014 $497",
  doItWithMe1: "Do It With Me \u2014 $5,497",
  takingYouToYourStart: "Taking you to your start page\u2026",
  openMyStartPage: "Open My Start Page",
  takingYouToTheCalendar: "Taking you to the calendar\u2026",
  uploadYourOrganizationsBylawsPdf: "Upload your organization's bylaws (PDF, Word or text)",
};

export const boardReactivationProposalPageText = {
  boardReactivationProjectProposal: "Board Reactivation Project Proposal",
  reactivateThePeopleWhoAre: "Reactivate the People Who Are Ready to Serve and Deal With the People Who Aren't",
  yourBoardShouldHelpCarry: "Your Board should help carry the organization forward. You should not have to keep carrying people who hold Board seats but are not prepared to take responsibility.",
  yourOrganizationAlreadyHasBoard: "Your organization already has Board Members. The problem is that some or most of them are no longer actively carrying the responsibilities the organization needs them to carry.",
  theAnswerIsNotTo: "The answer is not to keep sending reminders, pressuring people to participate or pretending the Board is functioning when the founder is still carrying most of the work.",
  weWillWorkThroughThe: "We will work through the Board Reactivation process together.",
  weWillUnderstandWhatCaused: "We will understand what caused the disengagement, give each Board Member an opportunity to recommit, have the difficult conversations that need to happen, identify who is prepared to stand up, help those who are not prepared to serve step down or transition appropriately, and give the people who remain clear areas of responsibility.",
  theGoalIsAnActive: "The goal is an active Board whose members understand what they own and how they are expected to help move the organization forward.",
  whatWeWillAccomplishTogether: "What We Will Accomplish Together",
  yourPaymentWasNotCompleted: "Your payment was not completed. You can get started whenever you're ready.",
  preferToDoItBy: "Prefer to Do It By Yourself?",
};

export const boardRecommitmentFormPageText = {
  pleaseContactThePersonWho: "Please contact the person who sent you this form for a new link.",
  yourBoardMemberProfileAmp: "Your Board Member Profile &amp; Recommitment Form has been submitted to ",
  theOrganizationWillReviewYour: "The organization will review your responses and follow up with you regarding your Board role and next steps.",
  lookingAheadAreYouWilling: "Looking ahead, are you willing and able to continue serving actively on the Board? ",
  iConfirmThatTheInformation: "I confirm that the information I have provided reflects my current availability, interests and willingness to serve. I understand that completing this form does not by itself change my current Board status and that the organization may follow up with me to discuss my role and responsibilities. ",
};

export const boardRecruitmentIntakePageText = {
  pleaseWaitWhileWeVerify: "Please wait while we verify your payment with Stripe.",
  weCouldNotFindA: "We could not find a completed qualifying purchase. If you just paid, please use the link Stripe returned you to. Otherwise, choose how you would like to launch your board recruitment:",
  doItYourself497: "Launch It Yourself \u2014 $297",
  doItWithMe1: "Do It With Us \u2014 $1,497",
  takingYouToYourStart: "Taking you to your start page\u2026",
  openMyStartPage: "Open My Start Page",
  takingYouToTheCalendar: "Taking you to the calendar\u2026",
  requiredForUsOrganizations: "Required for US organizations.",
  yourOrganizationBrandingOptionalProvide: "Your Organization Branding (optional \u2014 provide it once, we reuse it everywhere)",
  yourLogoAndBrandColors: "Your logo and brand colors are used to professionally brand every resource we create for you \u2014 application forms, emails, agreements, documents and board member portfolios. You will not be asked again.",
  organizationLogoPngJpgUp: "Organization Logo (PNG/JPG, up to 500KB)",
  linkedinOrganizationPageUrl: "LinkedIn Organization Page URL ",
  yourLinkedinProfileUrl: "Your LinkedIn Profile URL ",
  whatSkillsExperienceOrStrengths: "What skills, experience or strengths are already represented on your current board? ",
  whatAreTheBiggestChallenges: "What are the biggest challenges you are experiencing with your present board? ",
  whatSkillsExperienceRelationshipsOr: "What skills, experience, relationships or professional backgrounds would you like to add to your board? ",
  tellUsAboutTheOther: "Tell us about the other skills or experience ",
  whatDoYouMostNeed: "What do you most need your new board members to help your organization accomplish? ",
  isThereAnythingSpecificYou: "Is there anything specific you already know you want in the people you recruit?",
  howOftenDoesYourBoard: "How often does your board meet? ",
  tellUsYourMeetingSchedule: "Tell us your meeting schedule ",
  howAreYourBoardMeetings: "How are your board meetings held? ",
  tellUsTheTermLength: "Tell us the term length ",
  expectedMonthlyTimeCommitment: "Expected Monthly Time Commitment",
  maximumBoardSizeAccordingTo: "Maximum Board Size According to Your Bylaws or Governing Documents ",
  notSpecifiedIDontKnow: "Not Specified / I Don't Know",
  isThereAnythingElseI: "Is There Anything Else I Should Know Before We Start Recruiting Your Board?",
};

export const boardRecruitmentProposalPageText = {
  boardRecruitmentProjectProposal: "Board Recruitment Project Proposal",
  yourNonprofitShouldNotHave: "Your nonprofit should not have to keep struggling because you do not have the right people around the table.",
  whetherYouNeedOneNew: "Whether you need one new board member or need to build an entirely new board, the objective of this engagement is simple:",
  helpYouRecruitTheBoard: "Help you recruit the board members your nonprofit needs to grow, raise money, build relationships and move your mission forward.",
  overTheNextTwoWeeks: "Over the next two weeks, we will work together to identify, recruit, select and properly bring in skilled professionals with the experience, credibility, relationships and willingness to help your organization succeed.",
  hereIsHowWeWill: "Here Is How We Will Work Together",
  launchYourRecruitmentCampaign: "Launch Your Recruitment Campaign",
  duringOurFirst30Minute: "During our first 30-minute session, we will identify the exact board members your nonprofit needs and launch your board recruitment campaign.",
  weWillLaunchYourRecruitment: "We will launch your recruitment across various platforms using strategies we have mastered over the years.",
  theObjectiveIsToPut: "The objective is to put your opportunity in front of enough quality people that ",
  youHavePeopleToChoose: "you have people to choose from instead of simply accepting whoever happens to show up.",
  decideWhoYouWant: "Decide Who You Want",
  asApplicationsBeginComingIn: "As applications begin coming in, your job is to review every applicant and decide who you want to meet.",
  weWillInviteThemIn: "We will invite them in to meet with you so you can better understand their:",
  ifYouNeedHelpWith: "If you need help with the selection process, we can also provide the guidance and training you need to confidently choose who belongs on your board.",
  getYourBoardMembersUp: "Get Your Board Members Up To Speed and Ready To Build With You",
  onceYouHaveSelectedThe: "Once you have selected the people you want, we come back in.",
  recruitingSomebodyIsNotEnough: "Recruiting somebody is not enough.",
  yourNewBoardMembersNeed: "Your new board members need to understand what is expected of them and how they are supposed to support you and the organization.",
  weWillHelpMakeSure: "We will help make sure your new board members understand:",
  weWillAlsoTakeThem: "We will also take them through the necessary onboarding documentation, including:",
  thisWayYouWillGather: "This way, you will gather important information about who they are, their professional experience, skills, relationships and the areas of the organization where they are interested in serving so you can start positioning them.",
  inTwoWeeksYouWill: "In Two Weeks, You Will Have the Board Your Nonprofit Needs.",
  aBoardOfSkilledProfessionals: "A board of skilled professionals with the experience, credibility and willingness to help your organization succeed.",
  andBecauseYouParticipateIn: "And because you participate in the process with us, you will not only have new board members.",
  youWillUnderstandHowThe: "You will understand how the process works and be able to recruit board members again whenever your nonprofit needs them.",
  plusYouWillNotHave: "Plus, you will not have to start from scratch the next time your organization needs another board member. You will understand the process and have the tools and resources to recruit again.",
  weAlsoUnderstandThatEvery: "We also understand that every organization operates differently, so if you need to work within a different timeline, we are open to working with you within your organization's schedule.",
  butIfYouAreReady: "But if you are ready to make payment and get started today, we are offering you a discount",
  whatHappensAfterYouMake: "What Happens After You Make Payment",
  afterMakingPaymentYouWill: "After making payment, you will tell us about your organization and board and then choose a convenient time to meet with me for our first session so we can start recruiting your board together.",
  readyToBuildYourBoard: "Ready to Build Your Board?",
  youDoNotHaveTo: "You do not have to spend the next several months trying to figure out where to find board members or how to recruit them.",
  letSGetTheRight: "Let\u2019s get the right people around your table and get your organization moving forward.",
  yourPaymentWasNotCompleted: "Your payment was not completed. You can get started whenever you're ready.",
  preferToDoItBy: "Prefer to Do It By Yourself?",
  pleaseWaitWhileWeVerify: "Please wait while we verify your payment with Stripe.",
  weCouldNotFindA: "We could not find a checkout session. If you completed a payment, please contact us.",
  returnToTheProposal: "Return to the Proposal",
  weCouldNotConfirmYour: "We Could Not Confirm Your Payment Yet",
  ifYouCompletedThePayment: "If you completed the payment, it may still be processing. Please refresh this page in a moment or contact us for help.",
  returnToTheProposal2: "Return to the Proposal",
  tellMeAboutYourOrganization: "Tell Me About Your Organization and Board",
  takingYouToAShort: "Taking you to a short form so we can start your board recruitment\u2026",
};

export const boardTransformationPageText = {
  tellUsWhereToSend: "Tell Us Where to Send Your Results",
  whatDoesYourBoardLook: "What Does Your Board Look Like Today?",
  howManyBoardMembersDo: "How many Board Members do you currently have? ",
  howManyOfThoseBoard: "How many of those Board Members are currently active? ",
  doYouNeedMorePeople: "Do You Need More People Around the Table?",
  doYouThinkYouNeed: "Do you think you need to recruit new Board Members?",
  whatDoYouWantTo: "What Do You Want to Do About Your Inactive Board Members?",
  wouldYouLikeToReactivate: "Would you like to reactivate the Board Members who are currently inactive?",
  doYourBoardMembersCurrently: "Do your Board Members currently help raise money?",
  wouldYouLikeYourBoard: "Would you like your Board Members to actively help raise money for the organization?",
};

export const fundraisingPortfolioPageText = {
  pleaseContactThePersonWho: "Please contact the person who sent you this link.",
};


export const funnelFormControlsText = {
};


export const funnelOptionsPageText = {
  matchesTheSupportYouSelected: "Matches the support you selected",
  programAccessOpeningSoon: " Program Access Opening Soon",
  chooseHowYouWantTo: "Choose how you want to move forward",
  iWantToDoIt: "I want to do it myself.",
  recruitTheQualityBoardMembers: "Recruit the quality board members your nonprofit needs without guessing what to do next. Get the knowledge and resources you need to confidently build a stronger, more capable board yourself.",
  iWantGuidanceWhileI: "I want guidance while I recruit my board.",
  buildTheStrongerBoardYour: "Build the stronger board your nonprofit has been missing. Attract qualified professionals, choose the right people for your organization, and come out of the process with committed new board members ready to help your nonprofit move forward.",
  iWantSomeoneToWork: "I want someone to work with me.",
  getTheBoardMembersYour: "Get the board members your nonprofit needs without carrying the recruitment process alone. Bring in qualified professionals with the skills, experience, relationships and fundraising capacity your organization needs, and get them properly onboarded and ready to serve.",
  helpMeRecruitMyBoard: "Help Me Recruit My Board ",
  forNonprofitFoundersAndLeaders: "For nonprofit founders and leaders who are comfortable using technology and want the complete process, training, instructions and ready-to-use resources.",
  theFullTrainingPlusThe: "The full training plus the guided execution platform that walks you through the process and helps create the materials required to execute.",
  workDirectlyWithNonprofitBoard: "Work directly with Nonprofit Board Builder through the higher-support execution option to move the complete process forward with you.",
  offerSpecificImplementationGuidance: "Offer-specific implementation guidance",
  aClearPathFromDecision: "A clear path from decision to execution",
  scheduleMyExecutionPlanningCall: "Schedule My Execution Planning Call ",
};

export const funnelResultPageText = {
  buildingYourStartingPoint: "Building your starting point\u2026",
  basedOnlyOnYourAnswers: "Based only on your answers",
};

export const planningFormPageText = {
  pleaseContactThePersonWho: "Please contact the person who sent you this link and ask them to resend your personal form link.",
  yourIdeasWillBeConsidered: "Your ideas will be considered alongside the responses of the other Board Members as the organization's Fundraising Strategy Plan is developed.",
};

export const reactivateWithRooneyPageText = {
  getTheBoardMembersWho: "Get the Board Members who are ready to serve to stand up, take responsibility and help move the organization forward \u2014 and have the difficult conversations with those who are no longer prepared to carry Board responsibility.",
  boardReactivationTrainingVideoComing: "Board Reactivation Training Video Coming Soon",
  twoWaysICanHelp: "Two Ways I Can Help You Reactivate Your Board",
  chooseTheLevelOfSupport: "Choose the level of support that works best for you.",
  followTheBoardReactivationProcess: "Follow the Board Reactivation process yourself, work through your current Board Members, have the conversations that need to happen, and give the people who stay clear responsibility for helping move the organization forward.",
  reactivateMyBoardMyself497: "REACTIVATE MY BOARD MYSELF \u2014 $497",
  doItWithMe: "Do It With Me",
  workDirectlyWithRooneyThrough: "Work directly with Rooney through the Board Reactivation process so you can identify who is ready to stand up, deal with the people who are no longer prepared to serve, and rebuild an active Board with clear areas of responsibility.",
  reactivateMyBoardWithRooney: "REACTIVATE MY BOARD WITH ROONEY \u2014 $5,497",
  reactivateYourBoardWithRooney: "Reactivate Your Board With Rooney",
};

export const reactivateYourBoardYourselfPageText = {
  stopCarryingBoardMembersWho: "Stop Carrying Board Members Who Are Not Carrying the Mission",
  followTheProcessToFind: "Follow the process to find out who is ready to stand up, who needs clearer responsibility, and who is no longer prepared to serve \u2014 without pressuring people, destroying relationships or continuing to carry dead weight on your Board.",
  reactivateTheBoardYouAlready: "Reactivate the Board You Already Have",
  youWillWorkThroughYour: "You will work through your current Board one person at a time, understand what caused the disengagement, find out who is willing and able to recommit, have the conversations that need to happen, and give the people who remain clear areas of responsibility.",
  whatYouWillWalkAway: "What You Will Walk Away With",
  youAreDoingItYourself: "You Are Doing It Yourself. You Are Not Doing It Alone.",
  iWillShowYouThe: "I will show you the process, the platform will give you what you need to execute it, and when you get stuck, you can reach out to me for help.",
  yourPaymentWasNotCompleted: "Your payment was not completed. You can get started whenever you're ready.",
  wantMeToDoIt: "Want Me To Do It With You?",
};

export const reactivationStartHerePageText = {
  youAreAboutToWork: "You are about to work through your Board one person at a time.",
  theGoalIsToUnderstand: "The goal is to understand what caused the disengagement, find out who is willing and able to stand up, have the conversations that need to happen, and give the people who remain clear responsibility for helping move the organization forward.",
};

export const recruitCheckoutPageText = {
  startRecruitingSkilledProfessionalsIn: "Start Recruiting Skilled Professionals in Less Than 30 Minutes",
  recruitTheCommittedCapableBoard: "Recruit the committed, capable board members your nonprofit needs to move forward. Get the knowledge, resources, guidance, support and accountability you need to confidently build a stronger board around your mission. You will have what you need to execute and direct access to Rooney whenever you need help along the way. Your investment is also protected by our Recruitment Guarantee.",
  yourInvestmentIsProtectedBy: "Your investment is protected by our money-back Recruitment Guarantee. Click to read the Recruitment Guarantee terms.",
  moveFromKnowingYouNeed: "Move from knowing you need new board members to knowing exactly who to recruit and having what you need to begin reaching skilled professionals. Follow the guided process and you can start your recruitment campaign in less than 30 minutes.",
  everyKindOfBoard: "Every kind of board",
  useTheGuidedProcessTo: "Use the guided process to recruit committed professionals for your governing, working or advisory board based on the skills, relationships and experience your organization needs.",
  iHaveReadTheProgram: "I have read the program information and agree to the ",
  programAccessOpeningSoon: " Program Access Opening Soon",
};

export const recruitProcessPageText = {
  recruitingTheRightBoardIs: "Recruiting the right board is not just about bringing in the right people. It is also about bringing them in the right way so they understand the mission, commit to the organization and participate fully in building it.",
  havingWorkedWithHundredsOf: "Having worked with hundreds of nonprofits to strengthen their boards over the last decade, here are the 5 steps we recommend to build the board your organization needs.",
  identifyTheBoardMyNonprofit: "Identify the Board My Nonprofit Needs ",
  youDoNotNeedMore: "You do not need more names on your board. You need committed people with the capacity to help your nonprofit grow, raise money, build relationships and move the mission forward.",
  startBuildingMyBoard: "Start Building My Board ",
};

export const recruitWithRooneyPageText = {
  buildYourBoardWithMe: "Build your board with me.",
  boardRecruitmentVideoComingSoon: "Board Recruitment Video Coming Soon",
  yourInvestmentIsProtectedBy: "Your investment is protected by my 100% refund guarantee.",
  twoWaysICanHelp: "Two Ways I Can Help You Recruit Your Board",
  chooseTheLevelOfSupport: "Choose the level of support that works best for you.",
  recruitYourBoardYourself: "Recruit Your Board Yourself",
  watchMeRunTheProcess: "Watch me run the process, follow what I do, use the execution materials we provide and reach out whenever you need help along the way.",
  doItYourself497: "DO IT YOURSELF \u2014 $497",
  recruitYourBoardWithMe: "Recruit Your Board With Me",
  weHandleTheOutreachYou: "We handle the outreach, you decide who joins your board, and we help properly bring the people you select into your organization.",
  doItWithMe1: "DO IT WITH ME \u2014 $5,497",
  recruitYourBoardWithRooney: "Recruit Your Board With Rooney",
};

export const recruitYourBoardYourselfPageText = {
  watchMeRunTheRecruitment: "Watch me run the recruitment process, then do what I do for your own nonprofit.",
  buildTheBoardYourNonprofit: "Build the Board Your Nonprofit Needs",
  thisIsNotACourse: "This is not a course teaching theory. You will not simply learn about board recruitment \u2014 you will follow the process step by step, launch your recruitment campaign, work through your applicants, and properly bring the people you select into your organization.",
  iWillShowYouExactly: "I will show you exactly how I run the board recruitment process.",
  youWatchMeDoIt: "You watch me do it.",
  thenYouFollowWhatI: "Then you follow what I do for your own organization, using the materials created specifically for your nonprofit to actually recruit your board.",
  whatYouWillWalkAway: "What You Will Walk Away With",
  youAreDoingItYourself: "You Are Doing It Yourself. You Are Not Doing It Alone.",
  iWillShowYouThe: "I will show you the process, the platform will give you the materials you need to execute, and if you get stuck anywhere along the way, you can reach out to me for help using the Need Help With This Step? support built into every step.",
  learnTheProcessOnceUse: "Learn the Process Once. Use It Again Whenever You Need It.",
  byGoingThroughTheProcess: "By going through the process yourself, you learn how board recruitment actually works \u2014 and you can repeat it whenever your organization needs to recruit again.",
  afterMakingPaymentTellUs: "After making payment, tell us about your organization and board and begin following the process immediately. You can work toward launching your board recruitment campaign in the next 30 minutes using the instructions and materials provided.",
  yourPaymentWasNotCompleted: "Your payment was not completed. You can get started whenever you're ready.",
  wantMeToDoIt: "Want Me To Do It With You?",
};

export const recruitmentStartHerePageText = {
  followTheProcessUseThe: "Follow the process, use the materials we create for you, and ask for help anytime you need it.",
};

export const strategicPlanReviewPageText = {
  reviewTheConsolidatedThinkingBelow: "Review the consolidated thinking below. For each strategic area, support it, suggest a change, add an idea, or flag it for Board discussion. This is refinement, not formal adoption.",
  commentsDetailsOptional: "Comments / details (optional)",
};

export const strategyPlanPageText = {
  pleaseContactThePersonWho: "Please contact the person who sent you this link and ask them to resend it.",
};

export const strategyReviewPageText = {
  pleaseContactThePersonWho: "Please contact the person who sent you this link and ask them to resend the review link.",
  yourInputWillHelpThe: "Your input will help the Board work through the strategy and agree on the way forward together.",
  whyDoYouDisapproveOf: "Why do you disapprove of this idea? ",
  afterReviewingTheFundraisingStrategy: "After reviewing the Fundraising Strategy Plan, which best reflects your position? ",
  basedOnThisPlanWhere: "Based on this plan, where do you see yourself being able to contribute? ",
  whatSupportOrResourcesWould: "What support or resources would help you contribute effectively? (optional)",
};


export const blogPagesText = {
  nonprofitBoardBuilderInsights: "Nonprofit Board Builder Insights",
  practicalStrategiesToHelpYou: "Practical strategies to help you reactivate your present board, recruit the board members you are missing and activate your board to start raising money.",
  articlesAreComingSoon: "Articles are coming soon.",
  backToAllArticles: "Back to All Articles",
  latestFromNonprofitBoardBuilder: "Latest From Nonprofit Board Builder",
  t45GoActiveDelta: " 45) go(active + (delta ",
};

export const joinBoardPageText = {
  youDoNotNeedPreviousExperience: "You do not need previous board experience. You need a genuine commitment to contribute, learn and accept responsibility.",
  nonprofitBoardBuilderHelpsNonprofits: "Nonprofit Board Builder helps nonprofits reactivate, recruit and activate powerhouse fundraising boards.",
  theNonprofitBoardApplicantNetwork: "The Nonprofit Board Applicant Network",
  tellUsAboutYourProfessional: "Tell us about your professional background, the causes you care about and the type of board opportunity you are looking for.",
  weWillSaveYourProfile: "We will save your profile and email you when we have nonprofit board opportunities that match your experience, interests, location and availability.",
  joinTheBoardApplicantNetwork: "Join the Board Applicant Network ",
  currentlyOpenToProfessionalsLiving: " Currently open to professionals living in the United States and United Kingdom.",
  aClearPathToBoard: "A clear path to board service",
  bringWhatYouKnow: "Bring what you know",
  theyNeedPeopleWillingTo: "They need people willing to bring their skills, experience, relationships and commitment into the organization.",
  nonprofitBoardBuilder: "Nonprofit Board Builder",
  nonprofitBoardBuilder2: "Nonprofit Board Builder",
};

export const legalPageText = {
  lastUpdatedAugust42026: "Last updated August 4, 2026",
  nonprofitBoardBuilder: "Nonprofit Board Builder",
};



export const applicantConfirmationText = {
  yourBoardApplicantProfileHas: "Your Board Applicant Profile Has Been Saved",
  thankYouForJoiningThe: "Thank you for joining the Nonprofit Board Builder Applicant Network.",
  weWillReviewYourInformation: "We will review your information and email you whenever we have a nonprofit board opportunity that matches your professional experience, causes, location and availability.",
  toYourContactsFavouritesOr: " to your contacts, favourites or safe-sender list so you do not miss new board opportunities.",
  youCanUnsubscribeFromFuture: "You can unsubscribe from future opportunity emails at any time.",
  returnToNonprofitBoardBuilder: "Return to Nonprofit Board Builder",
};

export const applicantFormStepsText = {
  theBoardApplicantNetworkIs: "The Board Applicant Network is currently open only to professionals living in the United States and United Kingdom.",
  rSumOrCv: "R\u00e9sum\u00e9 or CV",
  optionalPdfDocOrDocx: "Optional. PDF, DOC or DOCX, up to 8 MB.",
  bySubmittingYourProfileYou: "By submitting your profile, you are asking Nonprofit Board Builder to save your professional information and contact you when a nonprofit board opportunity may match your skills, experience, causes, location and availability. You can unsubscribe from future board-opportunity emails at any time.",
  tellUsAboutYourself: "Tell Us About Yourself",
  pasteTheLinkToYour: "Paste the link to your LinkedIn profile",
  tellUsAboutYourProfessional: "Tell Us About Your Professional Background",
  tellUsAboutTheBoard: "Tell Us About the Board Opportunities You Want",
  exampleBirminghamAndSurroundingAreas: "Example: Birmingham and surrounding areas, anywhere in Alabama, or remote opportunities across the United States",
  tellUsHowYouCan: "Tell Us How You Can Contribute",
};

export const assessmentFormText = {
  nonprofitBoardBuilder: "Nonprofit Board Builder",
};

export const confirmationScreenText = {
  thankYouWeHaveReceived: "Thank You \u2014 We Have Received Your Board Assessment",
  weWillPersonallyReviewYour: "We will personally review your present board, identify which board members can be reactivated, determine the exact type of board members you may need to recruit, and assess what must happen to activate your board around fundraising.",
  pleaseLookOutForAn: "Please look out for an email from Nonprofit Board Builder shortly. We will explain what you need to do to begin transforming your present board into a powerhouse fundraising board and the available options for us to help you execute.",
  weMayAlsoContactYou: "We may also contact you using the phone number provided if we are unable to reach you by email.",
  nonprofitBoardBuilder: "Nonprofit Board Builder",
};

export const founderStorySectionText = {
  rooneyAkpesiriTheNonprofitBoard: "Rooney Akpesiri, the Nonprofit Board Builder",
};

export const landingPageText = {
  nonprofitBoardBuilder: "Nonprofit Board Builder",
  nonprofitBoardBuilder2: "Nonprofit Board Builder",
};

export const productToolsSectionText = {
  toolsBuiltForExecution: "Tools built for execution",
  weGiveYouTheStrategy: "We Give You the Strategy, Materials and Tools Required to Transform Your Board",
  youWillNotBeLeft: "You will not be left trying to work out what to do next. We create the forms, recruitment materials, planning tools and execution process required to reactivate, recruit and activate your board.",
  brightFuturesLiteracyInitiative: "Bright Futures Literacy Initiative",
  brightFuturesLiteracyInitiative2: "Bright Futures Literacy Initiative",
  applyToJoinOurBoard: "Apply to Join Our Board",
  helpExpandLiteracyAccessFor: "Help expand literacy access for children and families.",
  boardMemberMarcusReynolds: "Board Member: Marcus Reynolds",
  boardFundraisingPlanningForm: "Board Fundraising Planning Form",
  whichFundraisingAreasAreYou: "Which fundraising areas are you most confident supporting?",
  whichPeopleOrBusinessesCould: "Which people or businesses could you introduce to the organization?",
  regionalBanksLocalAccountingFirms: "Regional banks, local accounting firms and two Birmingham business associations.",
  whichPartOfTheFundraising: "Which part of the fundraising plan will you take responsibility for?",
  helpIdentifyTenLocalCorporate: "Help identify ten local corporate prospects and make five direct introductions.",
  whatSupportOrMaterialsDo: "What support or materials do you need?",
  corporatePartnershipOverviewEmailIntroduction: "Corporate partnership overview, email introduction and meeting talking points.",
  whenWillYouBegin: "When will you begin?",
  brightFuturesLiteracyInitiative3: "Bright Futures Literacy Initiative",
  boardRecommitmentAndPlanningForm: "Board Recommitment and Planning Form",
  doYouRemainCommittedTo: "Do you remain committed to the mission of the organization?",
  yesIAmFullyCommitted: "Yes, I am fully committed.",
  iNeedMoreInformationBefore: "I need more information before recommitting.",
  iAmNoLongerAble: "I am no longer able to continue.",
  canYouAttendScheduledBoard: "Can you attend scheduled board meetings consistently?",
  whichAreasAreYouWilling: "Which areas are you willing to support?",
  whichResponsibilityAreYouPrepared: "Which responsibility are you prepared to accept during the next twelve months?",
  helpBuildRelationshipsWithLocal: "Help build relationships with local employers and support the corporate fundraising committee.",
  whatSupportDoYouNeed: "What support do you need to succeed?",
  clearExpectationsQuarterlyTargetsAnd: "Clear expectations, quarterly targets and ready-to-use outreach materials.",
  iRecommitForTheNext: "I recommit for the next board term.",
  iWouldLikeToDiscuss: "I would like to discuss a different role.",
  iAmReadyToStep: "I am ready to step down respectfully.",
  submitMyRecommitmentDecision: "Submit My Recommitment Decision",
  boardProspectList: "Board Prospect List",
  applyToJoinOurBoard2: "Apply to Join Our Board",
  boardFundraisingPlanningForm2: "Board Fundraising Planning Form",
  boardRecommitmentAndPlanningForm2: "Board Recommitment and Planning Form",
};

export const testimonialCarouselText = {
  t45GoActiveDelta: " 45) go(active + (delta ",
};

export const stepFourText = {
  tellUsAboutYourBoard: "Tell Us About Your Board\u2019s Fundraising",
  showUsHowYourBoard: "Show us how your board participates in fundraising now.",
  iConfirmThatTheInformation: "I confirm that the information provided is accurate, that Nonprofit Board Builder may contact me about transforming our board, and that I agree to the Privacy Policy.",
  bySubmittingThisAssessmentYou: "By submitting this assessment, you are asking Nonprofit Board Builder to review your present board, contact you about your submission and send you relevant board recruitment, reactivation and fundraising activation information. You can unsubscribe from future emails at any time.",
};

export const stepOneText = {
  tellUsAboutYourOrganization: "Tell Us About Your Organization",
  helpUsUnderstandTheMission: "Help us understand the mission your board needs to move forward.",
  whereIsYourOrganizationLocated: "Where is your organization located? ",
  exampleRaiseMoneyBuildPartnerships: "Example: Raise money, build partnerships, strengthen governance, recruit volunteers or expand programs",
};

export const stepThreeText = {
  tellUsWhichBoardMembers: "Tell Us Which Board Members You Need",
  defineTheExperienceSkillsAnd: "Define the experience, skills and connections your board is missing.",
};

export const stepTwoText = {
  tellUsAboutYourPresent: "Tell Us About Your Present Board",
  giveUsAClearPicture: "Give us a clear picture of your board today.",
  numberOrNotSure: "Number or Not sure",
};


// Recruitment homepage copy. The existing intake is embedded by the route.
export const recruitmentHomeContent = {
  "brand": "Nonprofit Board Builder",
  "subtitle": "Board Recruitment",
  "logoMark": "NB",
  "eyebrow": "BOARD RECRUITMENT",
  "headline": "Recruit Board Members With Fundraising Experience",
  "subheadline": "Bring in the people with the skills and experience your organization needs to raise money and move your mission forward.",
  "primaryCta": "START MY BOARD RECRUITMENT",
  "introHeading": "Build The Board Your Organization Needs",
  "introParagraphs": [
    "Bringing in board members with fundraising experience can strengthen your organization's ability to raise money. Your board also needs people whose skills complement the board you already have.",
    "Start by telling us about your organization and the board you want to recruit. We will help you identify the exact type of people you need and show you how to recruit them."
  ],
  "formEyebrow": "LET'S START WITH YOUR ORGANIZATION",
  "formHeading": "How Many Board Members Do You Want To Recruit?",
  "formText": "",
  "videoEyebrow": "A MESSAGE FROM ROONEY",
  "videoHeading": "How You Recruit Your Board Members Matters",
  "videoText": "How you recruit these board members is as important as the quality of board members you bring in.",
  "videoTitle": "Rooney explains the board recruitment process",
  "processEyebrow": "THE RECRUITMENT PROCESS",
  "processHeading": "A Clear Path To Your New Board",
  "processText": "Follow the process with the guidance and customized materials you need at each stage.",
  "stages": [
    {
      "title": "Identify The People You Need",
      "text": "Understand the skills and experience that will complement your current board and help your organization succeed."
    },
    {
      "title": "Prepare Your Recruitment Campaign",
      "text": "Turn your board needs into a clear opportunity that the right people can recognize and respond to."
    },
    {
      "title": "Attract Qualified Applicants",
      "text": "Reach potential board members through your network and the platforms where suitable professionals can be found."
    },
    {
      "title": "Interview And Select",
      "text": "Get to know your applicants and assess how their experience and commitment fit your organization."
    },
    {
      "title": "Complete The Appropriate Checks",
      "text": "Use the checks your organization requires to support your appointment decisions."
    },
    {
      "title": "Onboard Your New Board Members",
      "text": "Help each new member understand the mission and their responsibilities so they can begin contributing."
    }
  ],
  "outcomesEyebrow": "THE BOARD YOU ARE BUILDING",
  "outcomesHeading": "Bring The Support Your Mission Needs Into The Room",
  "outcomes": [
    {
      "title": "Fundraising Experience",
      "text": "Recruit people who understand fundraising and can help your organization develop its ability to raise money."
    },
    {
      "title": "Skills That Complement Your Board",
      "text": "Identify the missing expertise that matters to your organization's priorities and recruit for those needs."
    },
    {
      "title": "Clear Expectations From The Beginning",
      "text": "Give applicants a proper selection and onboarding experience that establishes what serving on your board involves."
    },
    {
      "title": "A Process You Can Use Again",
      "text": "Learn how board recruitment works while building the resources your organization can return to when it needs to recruit again."
    }
  ],
  "testimonialsHeading": "See What Other Nonprofit Leaders Have Accomplished",
  "faqHeading": "Before You Get Started",
  "faqs": [
    {
      "q": "Can I recruit board members with fundraising experience?",
      "a": "Yes. Fundraising experience can be one of your recruitment priorities. The process helps you identify the experience your organization needs and communicate it clearly to potential applicants."
    },
    {
      "q": "What if I am building my first board?",
      "a": "Start with your mission and the support your organization needs. If you already have a board, use the process to identify people whose skills will complement it."
    },
    {
      "q": "Do I need to know exactly who to recruit?",
      "a": "You can begin with what your organization needs to accomplish. Identifying the types of board members who can help is part of the process."
    },
    {
      "q": "Will I receive materials for the recruitment process?",
      "a": "The guided recruitment system provides customized materials and tools for the recruitment stages. Review the offer for what is included before making payment."
    }
  ],
  "closingHeading": "Start Building The Board Your Mission Needs",
  "closingText": "Tell us about your organization and take the first step toward recruiting the people who can help you move it forward.",
  "login": "Log In",
  "howItWorks": "How It Works",
  "privacy": "Privacy Policy",
  "terms": "Terms",
  "footer": "Nonprofit Board Builder, LLC."
};
